"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateRoutingNumber = void 0;
const routing_number_checksum_calculator_1 = require("../routing-number-checksum-calculator");
const routing_number_scrubber_1 = require("../routing-number-scrubber");
function validateRoutingNumber(routingNumber) {
    const errors = [];
    const scrubbedRoutingNumber = routing_number_scrubber_1.scrubRoutingNumber(routingNumber);
    if (scrubbedRoutingNumber.length > 9) {
        errors.push(`Routing number ${routingNumber} is too long`);
    }
    if (scrubbedRoutingNumber.length < 9) {
        errors.push(`Routing number ${routingNumber} is too short`);
    }
    const checksum = routing_number_checksum_calculator_1.calculateRoutingNumberChecksum(scrubbedRoutingNumber);
    if (checksum % 10 !== 0) {
        errors.push(`Routing number ${routingNumber} checksum is not valid`);
    }
    return errors;
}
exports.validateRoutingNumber = validateRoutingNumber;
//# sourceMappingURL=validate-routing-number.js.map